import { t } from "@travily/i18n";
import communityIllustration from "@ui/assets/illustrations/community-animated.webp";
import { Wizard } from "@ui/components/Wizard";
import { WizardTextArea } from "@ui/components/WizardTextArea";
import type { ReactNode } from "react";

const COLOR = "yellow" as const;

export interface CommunityBioStepViewProps {
  /** Current stage, 1-indexed, for the progress bar. */
  currentStage: number;
  /** Total stages driving the progress bar. */
  totalStages: number;
  /** Back handler; omit on the first stage to hide the back affordance. */
  onBack?: () => void;
  /** Top-bar tertiary actions (e.g. "Questions?", "Save and finish later"). */
  topBarActions: ReactNode;
  /** Primary "Continue" / secondary "Skip" handler. */
  onPrimary: () => void;
  /** Whether the primary button shows its pending state. */
  primaryPending: boolean;
  /** Current bio value for the textarea. */
  bio: string;
  /** Fires on textarea change with the new value. */
  onBioChange: (value: string) => void;
}

export const CommunityBioStepView = ({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  bio,
  onBioChange,
}: CommunityBioStepViewProps) => {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.SecondaryButton onPress={onPrimary} mobileLabel={t("common.actions.skip")}>
        {t("common.actions.skip")}
      </Wizard.SecondaryButton>
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={communityIllustration} />}
        heading={t("web.communities.creator.steps.bio.show.title")}
        helper={t("web.communities.creator.steps.bio.show.subtitle")}
      >
        <div className="w-full max-w-[600px]">
          <WizardTextArea
            autoFocus
            color={COLOR}
            isLabelHidden
            label={t("web.accounts.setup.steps.bio.label")}
            onChange={onBioChange}
            placeholder={t("web.communities.creator.steps.bio.show.placeholder")}
            rows={4}
            value={bio}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
};
